export const BUDGET_TYPE_REQUEST = 'BUDGET_TYPE_REQUEST';
export const BUDGET_TYPE_SUCCESS = 'BUDGET_TYPE_SUCCESS';
export const BUDGET_TYPE_FAIL = 'BUDGET_TYPE_FAIL';